<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.location.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="p-2">
                <b-overlay :show="is_load" rounded="sm" >
                    <div class="location_data" v-if="!is_load">
                        <b-tabs content-class="mt-3" v-if="location.id > 0">
                            <b-tab v-for="(tab,index) in draw_tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index">
								<template slot="title">
									<slot :location="location" :name="'title_' + tab.index" >
										{{get_tab_title(tab)}}
									</slot>
								</template>

                                <slot :location="location" :name="tab.index" >
                                    <component v-bind:is="tab.index" :location="location" />
                                </slot>
                            </b-tab>
                        </b-tabs>

                        <slot :location="location" name="location_general_info" v-else></slot>
                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    {{__t("CLOSE")}}
                </button>

                <button type="button" v-on:click="save_location" class="btn btn-primary waves-effect waves-themed">
                    {{__t("SAVE")}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

import location_logs from "./tabs/location_logs";
import location_categories from "./tabs/location_categories";
import location_products from "./tabs/location_products";
import location_source_price from "./tabs/location_source_price";
import location_override from "./tabs/location_override.vue";
import yes_no from "../../../sys/radio/yes_no.vue";
import Delivery_block from "../location_general_tab/delivery_block/delivery_block.vue";

export default {
    name: "base_location_modal",
    props : {
        tabs_advanced : {
            type : Array
        },

        tabs_remove : {
            type : Array
        },

        extra_type : {
            type : String,
            default : "standart"
        }
    },

    components : {
        Delivery_block,
        yes_no,
        location_logs,
        location_categories,
        location_products,
        location_source_price,
        location_override
    },

    created() {
        EventBus.$on("location_edit", this.work_click);
        EventBus.$on('change_delivery_params',this.set_delivery_settings)

        try {
            if (this.tabs_advanced.length > 0) {
                this.tabs_advanced.map(tab => {
                    this.tabs.push(tab);
                })
            }

            if (this.tabs_remove.length > 0) {
                this.tabs = this.tabs.filter(tab => !this.tabs_remove.includes(tab.index));
            }

        }
        catch (e) {

        }
    },

    data() {
        return {
            tabs : [
                {
                    index : "location_general_info",
                    title : this.__t('MAIN_SETTINGS'),
                },

                {
                    index : "location_categories",
                    title : this.__t('Categories'),
                },

                {
                    index : "location_logs",
                    title : this.__t('LOGS'),
                },

                {
                    index : "location_products",
                    title : this.__t('ATTACH_PRODUCTS'),
                },

                {
                    index : "location_override",
                    title : this.__t('BASE_OVERRIDE'),
                },

            ],
            modal_position : "left",
            is_show_modal: false,
            is_load: false,

            enable_delivery : false,

            delivery : {
                auto_on : false,
                location_id : 0,
                filter_payment : "all",
            },

            agr_id : 0,
            location: {
                id: 0,
                parent_id : 0,
                title: "",
                uniq_id: "",
                address : "",

                payment_id : 0,
                pay_cache : 0,
                shipping_id : 0,

                overrides : {
                    "fields": {},
                    'types': {},
                    'is_enable' : false,
                },
                link_id : 0,
                source_id : 0
            },

            payments : [],
            worked_org : {
                "title" : ""
            },
        }
    },

    methods : {

        set_delivery_settings(data) {
            if(data.hasOwnProperty('loc_id')) {
                let loc_id = data.loc_id;
                let params = data.params;

                console.log('change_delivery',params);
                this.delivery.auto_on           = params.enable_delivery;
                this.delivery.location_id       = params.location_id;
                this.delivery.filter_payment    = params.filter_payment;
            }
        },


        close_modal() {
            this.close();
        },

        close() {
            //this.tabs = [];
            this.location = this.dfault_rest;
            this.agr_id = 0;
            this.delivery = {
                auto_on : false,
                location_id : 0,
                filter_payment : "all",
            }

            this.is_show_modal = false;
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.draw_tabs) {
                this.draw_tabs[tab].is_active = false;
            }
            this.draw_tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.draw_tabs[obj].index, user_id: this.user_id});
        },

        work_click(params) {
            let org_id = 0;
            let location_id = 0;
            let org_obj = null;


            if(params.hasOwnProperty("org_id")) {
                org_id = parseInt(params.org_id);
            }

            if(params.hasOwnProperty("location_id")) {
                location_id = parseInt(params.location_id);
            }

            if(params.hasOwnProperty("org_obj")) {
                org_obj = params.org_obj;
            }

            if(params.hasOwnProperty("provider_id")) {
                this.agr_id = params.provider_id;
            }

            if(org_obj != null) {
                this.worked_org = org_obj;
                if(org_obj.hasOwnProperty("linked_childrens")) {
                    this.location.linked_childrens = org_obj.linked_childrens;
                }
            }


            let type = '';
            if(params.hasOwnProperty("type")) {
                if(this.extra_type === params.type) {
                    this.is_show_modal = true;
                }
            }
            else {

                if(this.extra_type === 'standart') {
                    this.is_show_modal = true;
                    this.location.parent_id = org_id;
                }
            }

            this.load_location(location_id,type);
        },

        async load_location(_id,type) {

            let url = _id > 0 ? `/aggregators/locations/${_id}` : `/aggregators/${this.agr_id}/locations/0`;
            this.is_load = true;

            await agr_api.get(url).then(({data}) => {
                if (data.status === "operation_success") {
                    if (data.data != undefined && data.data.hasOwnProperty("id")) {
                        let cur_org = this.location.parent_id;
                        this.location = {...this.location, ...data.data};
                        this.location.sub_type = type;

                        if (cur_org > 0) {
                            this.location.parent_id = cur_org;
                        }

                        this.location.overrides = {
                            "fields": {},
                            'types': {},
                            'is_enable' : false,
                        };

                        if(_id > 0) {
                            return this.load_overrides(parseInt(this.location.id)).then(({data}) => {
                                if (data.status === "operation_success") {
                                    let resp_data = data.data;
                                    this.location.overrides = {
                                        "fields": resp_data,
                                        'types': data.message,
                                        'is_enable': resp_data.id > 0
                                    };
                                }
                                return data;
                            });
                        }
                    }
                }
            })
                .catch((error) => {
                    if (error.response && error.response.hasOwnProperty('data')) {
                        EventBus.$emit('show_toast', {
                            err: error.response.data.message,
                            type: "danger",
                            title: response.data.status
                        });
                    } else {
                        EventBus.$emit('show_toast', {
                            err: "Unexpected error occurred",
                            type: "danger",
                            title: "Error"
                        });
                    }
                })
                .finally(() => {
                    this.is_load = false;
                });
        },

        async load_overrides(id) {
            return  agr_api.get('/aggregators/locations/' + id + '/settings/overrides');
        },

        async save_location() {
            this.is_load = true;
            let url = '/aggregators/'+ this.agr_id +'/locations/'+ this.location.id;
            if(this.location.id  > 0 ) {
                url = '/aggregators/locations/'+ this.location.id;
            }
            let overrides = null;
            let location = this.location;

            if(location.hasOwnProperty('overrides')) {
                 overrides = this.location.overrides;
                 delete location.overrides;
            }

            await agr_api.put(url,{
                'store_item' : location,
                'overrides' : overrides,
                'delivery' : this.delivery,
            }).then(({data}) => {

                if (data.status === "operation_success") {
                    EventBus.$emit('after_save_location',data.data);
                    EventBus.$emit('reload_locations');
                    this.close();
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    computed: {

        draw_tabs() {
            let tabs_res = JSON.parse(JSON.stringify(this.tabs));
            if (this.has_source_price) {
                tabs_res.push({
                    index : "location_source_price",
                    title : this.__t('SOURCE_PRICE'),
                })
            }

            return tabs_res;
        },

        has_source_price() {
            try {
                if (this.location.hasOwnProperty("organization")) {
                    let org = this.location.organization;
                    if (org.provider == 'poster_org' || org.provider == 'nexus_org' || org.provider == 'mark4_org') {
                        return true;
                    }
                }
            }
            catch (e) {

            }

            return false;
        },

        dfault_rest() {
            return {
                id: 0,
                parent_id : 0,
                title: "",
                uniq_id: "",
                address : "",
                payment_id : 0,
                link_id : 0,
                shipping_id : 0,
                pay_cache : 0,
                children : [],
                overrides : {
                    "fields": {},
                    'types': {},
                    'is_enable' : false,
                },
            }
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }

            return "modal-dialog-right modal-xl";
        },
    }
}
</script>

<style scoped>

</style>
